export default __webpack_public_path__ + "7625e92311aea18ccbf5212ef4123cac.jsonld";